import React from 'react';
import {
  ListItem as MUIListItem,
  ListItemText as MUIListItemText,
  MenuItem,
  List as MUIList,
  Grid,
  Box,
  BoxProps,
  ListItemProps,
} from '@mui/material';
import styled from 'styled-components';
import { colors } from 'spw-theme';
import { DraggingStyle, NotDraggingStyle } from 'react-beautiful-dnd';
import { Link } from 'react-router-dom-v5';

export const ScenariosTitle = styled.h1`
  font-family: Roboto;
  font-style: normal;
  font-weight: 300;
  font-size: 32px;
  line-height: 34px;
  color: #000000;
`;

export const USFBox = styled.span`
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: #000000;
`;

export const UpdateWorksheetWarning = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 100%;

  span {
    color: ${colors.fontColor};
    font-size: 14px;
  }

  img {
    width: 22px;
    height: 22px;
    margin-left: 8px;
  }
`;

export const CurrentPath = styled((props: BoxProps) => (
  <Box display="flex" {...props} />
))`
  && {
    padding-left: 10px;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    height: 36px;
    position: sticky;
    top: 52px;
    z-index: 1;
    background-color: white;
    margin-top: -8px;
    padding-top: 8px;
    padding-bottom: 10px;
  }
`;

export const DownloadButton = styled(Box)`
  && {
    display: flex;
    flex-direction: row;
    margin-left: 50px;
  }
`;

export const PathArrow = styled((props: BoxProps) => (
  <Box display="flex" alignItems="center" {...props} />
))`
  && {
    margin: 0px 14px;

    img {
      margin-top: 4px;
    }
  }
`;

export const BuildingPath = styled(Link)`
  && {
    color: #919191;
    cursor: pointer;
    display: flex;
    align-items: center;

    p {
      margin: 0px;
    }
  }
`;

export const ScenarioName = styled((props: BoxProps) => (
  <Box display="flex" alignItems="center" {...props} />
))`
  && {
    font-weight: 500;
    font-size: 18px;
    color: #000000;
  }
`;

// this seems to be an issue with MUI
// see discussion:
// https://github.com/mui-org/material-ui/issues/14971

export const ListItem = styled((props: ListItemProps) => (
  <MUIListItem {...props} />
))`
  && {
    cursor: pointer;
    height: 52px;
    background-color: ${colors.white};
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    padding-top: 0px;
    padding-bottom: 0px;

    &.detail-item {
      padding-right: 0px;
      padding-left: 0px;
    }

    &.dragging {
      background: #eeeeee;
    }

    &.total-program-item-detail {
      padding-left: 0px;
      padding-right: 0px;
    }

    &.total-program-item {
      padding-left: 0;

      div {
        div {
          font-style: normal;
          font-size: 14px;
          line-height: 16px;
          /* identical to box height, or 114% */

          display: flex;
          align-items: center;
          letter-spacing: 0.25px;

          /* Text/Default */

          color: #000000;
        }

        &.strong {
          font-weight: bold;
        }
      }
    }

    &.departments-item {
      padding-left: 0;
    }

    &.departments-nested-item {
      background-color: ${colors.lightGreyBackground};
    }
  }

  &.selected {
    background-color: ${colors.selectedListItem};
  }

  &:hover {
    background: #eeeeee;
  }
`;

export const ListItemText = styled(MUIListItemText)`
  && {
    font-family: Roboto;
    font-style: normal;
    font-size: 14px;
    line-height: 16px;
    width: 200px;
    white-space: nowrap;

    span {
      width: 200px;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 14px;
    }

    &.department {
      span {
        width: 170px;
      }
    }

    &.detail-item {
      span {
        width: 140px;
      }
    }

    &.detail-item-department {
      span {
        width: 130px;
      }
    }

    /* identical to box height, or 114% */
    letter-spacing: 0.25px;
    color: ${colors.black};

    &.mb-0 {
      margin-bottom: 0px;
    }
  }
`;

export const ListItemColumn = styled(Box)`
  display: flex;
  align-items: center;
  height: 100%;
`;

export const menuStyles = {
  border: `1px solid ${colors.offWhite}`,
  boxShadow: '2px 2px 4px rgba(0, 0, 0, 0.2)',
  borderRadius: '4px',
  width: '82px',
};

export const totalProgramMenuStyles = {
  ...menuStyles,
  width: '105px',
};

export const StyledMenuItem = styled(MenuItem)`
  && {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
  }
`;

export const Pill = styled.div`
  && {
    background-color: ${(props) => `${props.color}`};
    width: 40px;
    height: 24px;
    border-radius: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 6px;
    font-size: 12px;
    font-weight: 700;
  }
`;

export const Header = styled.div`
  && {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    white-space: nowrap;

    &.start {
      align-items: flex-start;
      justify-content: flex-end;
      height: 24px;
    }

    &.end {
      align-items: flex-end;
      justify-content: flex-end;
    }

    &.center-bottom {
      justify-content: flex-end;
      height: 24px;
    }

    div {
      font-family: Roboto;
      font-style: normal;
      font-weight: 500;
      font-size: 10px;
      line-height: 12px;
      text-align: center;
      letter-spacing: 0.25px;
      text-transform: uppercase;
      white-space: nowrap;

      &.light {
        font-weight: normal;
      }
    }
  }
`;

export const DeptColumnHeader = styled.div`
  && {
    display: flex;
    flex-direction: column;
    white-space: nowrap;

    &.center {
      align-items: center;
    }

    &.end {
      div {
        text-align: right;
      }
    }

    div {
      font-family: Roboto;
      font-style: normal;
      font-weight: 500;
      font-size: 10px;
      line-height: 12px;
      letter-spacing: 0.25px;
      text-transform: uppercase;
      white-space: nowrap;

      &.light {
        font-weight: normal;
      }
    }
  }
`;

export const ListHeader = styled((props: BoxProps) => (
  <Box {...props} display="flex">
    {props.children}
  </Box>
))`
  && {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    margin: 0px;
    width: 100%;
    background: ${colors.lightGreyBackground};
  }
`;

export const ListRow = styled((props: BoxProps) => (
  <Box {...props} display="flex">
    {props.children}
  </Box>
))`
  && {
    margin: 0px;
    width: 100%;
  }
`;
export const ListColumn = styled(Box)`
  && {
    padding: 12px;
    padding-left: 0px;
    box-sizing: border-box;
    height: 100%;

    &.vertical-center {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &.right {
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }

    &.left {
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }

    &.first-item {
      padding-left: 42px;
      padding-right: 0px;
    }
  }
`;

export const ListColumnDepartment = styled(Box)`
  && {
    padding: 0px 12px 0px 0px;
    box-sizing: border-box;

    &.pl-12 {
      padding-left: 12px;
    }

    &.first-item {
      padding-left: 42px;
      margin-left: 0;
    }
  }
`;

export const Value = styled.div`
  && {
    font-family: Roboto;
    font-style: normal;
    font-size: 14px;
    line-height: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const List = styled(MUIList)`
  && {
    padding: 0;
  }
`;

export const getItemStyle = (
  isDragging: boolean,
  draggableStyle: DraggingStyle | NotDraggingStyle
) => ({
  background: isDragging ? '#EEEEEE' : 'white',

  // styles we need to apply on draggables
  ...draggableStyle,
});

export const getListStyle = (isDraggingOver: boolean) => ({
  background: isDraggingOver ? 'rgba(3,178,171, 0.1)' : 'white',
  width: '100%',
});

export const SubHeaderRow = styled(Grid)`
  && {
    background-color: #e0e0e0;
    border-radius: 4px;
    height: 40px;
    display: flex;
    align-items: center;
    padding-left: 0px;
    padding-right: 0px;
  }
`;

export const DeptListHeader = styled.div`
  && {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    /* identical to box height, or 133% */

    text-transform: uppercase;
    margin-bottom: 8px;
    margin-top: 16px;
  }
`;

export const ListSubHeader = styled(Grid)`
  && {
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 12px;

    letter-spacing: 0.25px;
    text-transform: uppercase;

    margin-left: -4px;

    &.first-item {
      padding-left: 49px;
      margin-left: 0;
      margin-right: 6px;
    }
  }
`;

export const NestedValue = styled.div`
  && {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0.25px;
    color: #000000;
    width: 170px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &.department {
      width: 220px;
    }
  }
`;

export const ProgramSummaryNestedValue = styled(NestedValue)`
  && {
    width: 200px;

    &.department {
      width: 170px;
    }
  }
`;

export const SecondaryIdentifierValue = styled.div`
  && {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    width: 170px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
